module.exports = __webpack_public_path__ + "img/cup.7f97888b.svg";